import { isOpx } from 'owa-opx';
import { deepLinkMailModuleRouteHandler } from './deepLinkMailModuleRouteHandler';
import { deepLinkYammerRouteHandler } from './deepLinkYammerRouteHandler';
import getCurrentDeepLinkRoute from './getCurrentDeepLinkRoute';
import { RegisterRouteFunction, RouterOptions } from 'owa-router';
import deepLinkAttachmentRouteHandler, {
    deepLinkInternetMessageIdAttachmentRouteHandler,
} from './deepLinkAttachmentRouteHandler';
import {
    deepLinkComposeRouteHandler,
    deepLinkReplyRouteHandler,
    deepLinkReplyAllRouteHandler,
    deepLinkComposeDraftRouteHandler,
} from './deepLinkComposeRouteHandler';
import { deepLinkSearchAnswerRouteHandler } from './deepLinkSearchAnswerRouteHandler';
import { deepLinkSaveToCloudRouteHandler } from './deepLinkSaveToCloudRouteHandler';

export let mailRouterOptions: RouterOptions = {
    routeGenerator: Promise.resolve(getCurrentDeepLinkRoute),
    defaultRoute: '/deeplink',
    staticUrl: isOpx(), // don't update the address bar in OPXs
};

export async function initializeDeepLinkMailRoutes(registerRoute: RegisterRouteFunction) {
    // Helper function to register a deeplink + OPX version of each route
    const registerRouteHelper: RegisterRouteFunction = (route, onNavigateTo, onNavigateFrom) => {
        registerRoute('/deeplink' + route, onNavigateTo, onNavigateFrom);
        registerRoute('/opxdeeplink' + route, onNavigateTo, onNavigateFrom);
    };

    registerRouteHelper('/searchAnswer', deepLinkSearchAnswerRouteHandler);
    registerRouteHelper('/yammer/:threadId', deepLinkYammerRouteHandler);
    registerRouteHelper('/read/:itemId', deepLinkMailModuleRouteHandler);
    registerRouteHelper('/readonly/:readonlyItemId', deepLinkMailModuleRouteHandler);
    registerRouteHelper(
        '/readimid/:base64EncodedInternetMessageId',
        deepLinkMailModuleRouteHandler
    );
    registerRouteHelper('/readconv/:convId', deepLinkMailModuleRouteHandler);
    registerRouteHelper(
        '/read/group/:groupDomain/:groupAlias/:itemId',
        deepLinkMailModuleRouteHandler
    );
    registerRouteHelper(
        '/readconv/group/:groupDomain/:groupAlias/:convId',
        deepLinkMailModuleRouteHandler
    );
    registerRouteHelper('/compose', deepLinkComposeRouteHandler);
    registerRouteHelper('/compose/reply', deepLinkReplyRouteHandler);
    registerRouteHelper('/compose/replyall', deepLinkReplyAllRouteHandler);
    registerRouteHelper('/compose/draft', deepLinkComposeDraftRouteHandler);
    registerRouteHelper('/compose/:draftId', deepLinkComposeRouteHandler);
    registerRouteHelper(
        '/internetmessageidattachment/:base64EncodedInternetMessageId/:attachmentIndex',
        deepLinkInternetMessageIdAttachmentRouteHandler
    );
    registerRouteHelper(
        '/attachment/:itemId/:attachmentId/:isEdit',
        deepLinkAttachmentRouteHandler
    );
    registerRouteHelper('/attachment/:itemId/:attachmentId', deepLinkAttachmentRouteHandler);
    // TODO: Remove additional deep link route after Group Card starts using new route
    registerRouteHelper(
        '/attachment/:itemId/:attachmentId/group/:groupDomain/:groupAlias',
        deepLinkAttachmentRouteHandler
    );
    registerRouteHelper(
        '/attachment/group/:groupDomain/:groupAlias/:itemId/:attachmentId',
        deepLinkAttachmentRouteHandler
    );

    registerRoute(
        '/deeplink/saveAndEdit/:itemId/:attachmentId/:subscriptionId',
        deepLinkSaveToCloudRouteHandler
    );

    registerRouteHelper('', deepLinkMailModuleRouteHandler);
}
